import * as React from 'react';

interface Props {
  children: React.ReactNode;
  hide?: boolean;
}

export const LabelContent: React.FC<Props> = ({ children, hide }) => {
  return (
    <span
      className={`text-xs text-grey-600 ${hide ? 'sr-only' : 'block'} mb-1`}
    >
      {children}
    </span>
  );
};
